import React from 'react'
import { Col, Container, Row } from 'react-grid-system'

import EloCorp from 'assets/svg/elo-corporativo.svg'
import Boleto from 'assets/svg/boleto.svg'
import CertificadoValidIcon from 'assets/svg/certificado_valid_icon.svg'
import SiteBlindado from 'assets/svg/site-blindado.svg'
import FacebookIcon from 'assets/svg/social-medias/facebook_icon.svg'
import TwitterIcon from 'assets/svg/social-medias/twitter_icon.svg'
import LinkedinIcon from 'assets/svg/social-medias/linkedin_icon.svg'

import { CREDIT_CARD_PAYMENT } from 'constants/environment'

import './StampsContainer.scss'

const StampsContainer = () => (
    <div className="stamps-container">
        <Container className="stamps-container__container">
            <Row>
                <Col
                    className="stamps-container__column"
                    xl={4}
                    lg={4}
                    md={4}
                    sm={12}
                >
                    <h2 className="stamps-container__title">
                        {CREDIT_CARD_PAYMENT ? 'Meios' : 'Meio'} de pagamento
                    </h2>
                    <div className="stamps-container__stamps">
                        {CREDIT_CARD_PAYMENT && (
                            <img
                                src={EloCorp}
                                alt="Selo Elo"
                                data-gtm-event-category="alelo:loja-virtual"
                                data-gtm-event-action="clique:meios-de-pagamento"
                                data-gtm-event-label="elo"
                                style={{ width: '78px', height: '43px' }}
                            />
                        )}
                        <img
                            src={Boleto}
                            alt="Selo Boleto"
                            data-gtm-event-category="alelo:loja-virtual"
                            data-gtm-event-action="clique:meios-de-pagamento"
                            data-gtm-event-label="boleto"
                            style={{ width: '45px', height: '49px' }}
                        />
                    </div>
                </Col>
                <Col
                    className="stamps-container__column"
                    xl={4}
                    lg={4}
                    md={4}
                    sm={12}
                >
                    <h2 className="stamps-container__title">Site seguro</h2>
                    <div className="stamps-container__stamps">
                        <a
                            id="s18_img_wrapper_vd_image_125-50_en"
                            href="https://www.globalsign.eu/"
                            target="_blank"
                            title="CLICK TO VERIFY: This site uses a GlobalSign SSL Certificate to secure your personal information."
                            rel="noopener noreferrer"
                            data-gtm-event-category="alelo:loja-virtual"
                            data-gtm-event-action="clique:selos-de-seguranca"
                            data-gtm-event-label="valid"
                        >
                            <img
                                src={CertificadoValidIcon}
                                alt="SSL"
                                border="0"
                                id="ss_img"
                                style={{ width: '50px', height: '40px' }}
                            />
                        </a>
                        <span
                            data-gtm-event-category="alelo:loja-virtual"
                            data-gtm-event-action="clique:selos-de-seguranca"
                            data-gtm-event-label="site-blindado"
                        >
                            <img
                                src={SiteBlindado}
                                alt="Selo Site blindado"
                                style={{ width: '142px' }}
                            />
                        </span>
                    </div>
                </Col>
                <Col
                    className="stamps-container__column"
                    xl={4}
                    lg={4}
                    md={4}
                    sm={12}
                >
                    <h2 className="stamps-container__title">Redes sociais</h2>
                    <div className="stamps-container__stamps">
                        <a
                            className="stamps-container__social-media"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://www.facebook.com/AleloBrasil"
                            data-gtm-event-category="alelo:loja-virtual"
                            data-gtm-event-action="clique:redes-sociais"
                            data-gtm-event-label="facebook"
                        >
                            <img src={FacebookIcon} alt="Icone Facebook" />
                        </a>
                        <a
                            className="stamps-container__social-media"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://twitter.com/alelobrasil"
                            data-gtm-event-category="alelo:loja-virtual"
                            data-gtm-event-action="clique:redes-sociais"
                            data-gtm-event-label="twitter"
                        >
                            <img src={TwitterIcon} alt="Icone Twitter" />
                        </a>
                        <a
                            className="stamps-container__social-media"
                            target="_blank"
                            rel="noopener noreferrer"
                            href="https://www.linkedin.com/company/alelo-brasil/?originalSubdomain=br"
                            data-gtm-event-category="alelo:loja-virtual"
                            data-gtm-event-action="clique:redes-sociais"
                            data-gtm-event-label="linkedin"
                        >
                            <img src={LinkedinIcon} alt="Icone Linkedin" />
                        </a>
                    </div>
                </Col>
            </Row>
        </Container>
    </div>
)

export default StampsContainer
